import { BidTruckingGetModel } from "api";
import { buildQuery, containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/tripCouplings";
const couplingsQuery = { orderBy: "id desc" };

const getCouplingByBid = (bid: BidTruckingGetModel) => {
    const filter: { [x: string]: number | {} } = {
        "driver/id": bid.driver!.id,
        "car/id": bid.carOption!.carId!,
        startedAt: { le: new Date(bid.bidPoints![0].planEnterDate) },
        endedAt: { ge: new Date(bid.bidPoints![0].planEnterDate) },
    };
    if (bid.trailerOption) {
        filter["trailer/trailerId"] = bid.trailerOption.trailerId!;
    }
    const query = buildQuery({ filter });
    return request(`${resource}/getlist${query}`, { method: "GET" }).then((data) => data && data.length > 0 && data[0]);
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...couplingsQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const list = (params: {}, filter = {}) => {
    return request(`${resource}/getlist${containsQuery(params, { filter })}`, { method: "GET" });
};

export { getCouplingByBid, index, list };
